import React from "react";
import { motion } from "framer-motion";
import {
  FiUserPlus, FiSlash, FiAlertTriangle, FiCheckCircle,
  FiActivity, FiEdit, FiLayers, FiFileText
} from "react-icons/fi";
import Footer from "./Footer";

const TermsandConditon = () => {
  const colors = {
    bg: '#000000',
    accent: '#22c55e',
    card: 'rgba(255, 255, 255, 0.03)',
    border: 'rgba(255, 255, 255, 0.08)',
    text: '#ffffff',
    muted: 'rgba(255, 255, 255, 0.5)',
    glow: 'rgba(34, 197, 94, 0.15)'
  };

  const sections = [
    {
      icon: <FiCheckCircle />,
      title: "Acceptance of Terms",
      content: "By using SnapED CodeCampus, you agree to these Terms and Conditions. If you do not agree, please refrain from using our services. We reserve the right to update these terms at any time."
    },
    {
      icon: <FiEdit />,
      title: "Changes to Terms",
      content: "We may revise these terms periodically. Continued use of the website after changes constitutes acceptance. We recommend checking this page regularly for any updates."
    },
    {
      icon: <FiLayers />,
      title: "Use of Services",
      content: "Our platform provides educational resources and coding tutorials. You agree to use these services only for lawful purposes and in a way that does not disrupt others' experience."
    },
    {
      icon: <FiUserPlus />,
      title: "Account Security",
      content: "You are responsible for maintaining the confidentiality of your account credentials. Notify us immediately of any unauthorized access to your account."
    },
    {
      icon: <FiFileText />,
      title: "Member Content",
      content: "By posting content, you grant us a license to use it for platform operations. You retain ownership but are responsible for ensuring your content doesn't violate any laws."
    },
    {
      icon: <FiSlash />,
      title: "Prohibited Acts",
      content: "Harassment, spamming, distributing malware, or attempting to breach our security is strictly prohibited and may lead to immediate account termination."
    },
    {
      icon: <FiAlertTriangle />,
      title: "Liability Limit",
      content: "SnapED CodeCampus is not liable for any damages arising from your use of the website. We provide materials 'as-is' without warranties of any kind."
    },
    {
      icon: <FiActivity />,
      title: "Governing Law",
      content: "These terms are governed by the laws of India. Any disputes will be resolved in the courts of New Delhi, India through binding arbitration."
    }
  ];

  return (
    <div style={{ background: colors.bg, minHeight: '100vh', color: '#fff' }}>
      {/* Hero Section */}
      <section style={{
        padding: '160px 20px 80px',
        position: 'relative',
        textAlign: 'center',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute', top: '-10%', left: '50%', transform: 'translateX(-50%)',
          width: '800px', height: '600px',
          background: `radial-gradient(circle, ${colors.glow} 0%, transparent 70%)`,
          filter: 'blur(100px)', pointerEvents: 'none', zIndex: 0
        }} />

        <div style={{ position: 'relative', zIndex: 1, maxWidth: '800px', margin: '0 auto' }}>
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            style={{
              width: '64px', height: '64px',
              background: 'rgba(34,197,94,0.1)',
              borderRadius: '20px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: colors.accent, margin: '0 auto 32px',
              border: `1px solid ${colors.border}`
            }}
          >
            <FiFileText size={32} />
          </motion.div>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            style={{
              fontSize: 'clamp(2.5rem, 6vw, 4.5rem)',
              fontWeight: 900,
              letterSpacing: '-0.04em',
              lineHeight: 1,
              marginBottom: '24px'
            }}
          >
            Terms & <span style={{ color: colors.accent }}>Conditions</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            style={{ fontSize: '18px', color: colors.muted, lineHeight: 1.6 }}
          >
            Please read these terms carefully before using our platform.
            By accessing SnapED codeCampus, you agree to be bound by these standards.
          </motion.p>
        </div>
      </section>

      {/* Content Grid */}
      <section style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px 120px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '24px'
        }}>
          {sections.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              style={{
                background: colors.card,
                backdropFilter: 'blur(20px)',
                border: `1px solid ${colors.border}`,
                borderRadius: '24px',
                padding: '32px',
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                transition: 'all 0.3s ease'
              }}
            >
              <div style={{ color: colors.accent, fontSize: '24px' }}>
                {section.icon}
              </div>
              <h3 style={{ fontSize: '20px', fontWeight: 700, margin: 0 }}>{section.title}</h3>
              <p style={{ fontSize: '15px', color: colors.muted, lineHeight: 1.7, margin: 0 }}>
                {section.content}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Footer Note */}
        <div style={{ textAlign: 'center', marginTop: '80px', color: colors.muted, fontSize: '14px' }}>
          Effective Date: March 2026 • SnapED codeCampus • New Delhi, India
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsandConditon;